<template>
  <!-- For pro version don't remove it, need this button -->
  <!-- <button class="btn btn-primary" @click="openNewWindow" style="position: fixed; top: 10px; right: 10px; z-index: 1000;">打開播放窗口</button> -->
  <div id="player-container">
    <!-- <div v-if="showUsername" class="username-display" style="position: fixed; top: 10px; right: 10px; z-index: 999999;">
      {{ userStore.user?.username }}
    </div> -->
    <div class="player-root">
      
      <div v-if="balancePoints <= 0">餘額不足，請充值！</div>
      <div v-else>
        <div v-if="stateB">歌曲資料無法下載</div>
        <div v-else-if="!stateA">歌曲資料下載中請稍待！</div>
        
        <div v-else class="video-container">
          <div v-if="isYouTube" class="youtube-container">
            <iframe
              id="youtube-player"
              :src="`https://www.youtube-nocookie.com/embed/${videoId}?enablejsapi=1&origin=${encodeURIComponent(origin)}&autoplay=1&controls=1&modestbranding=1&rel=0&fs=1&playsinline=1&iv_load_policy=3`"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
              style="border: none;"
              sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation"
            ></iframe>
            <!-- <iframe
              id="youtube-player"
              :src="`https://www.youtube.com/embed/${videoId}?enablejsapi=1&origin=${encodeURIComponent(origin)}&autoplay=1&controls=1&modestbranding=1&rel=0&fs=1&playsinline=1`"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; compute-pressure"
              allowfullscreen
              style="border: none;"
              sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation"
            ></iframe> -->
          </div>
          <longze-video-play
            v-else
            autoplay
            ref="videoPlayer"
            width="100%"
            height="100%"
            :src="videoOptions.src"
            :type="videoOptions.type"
            :controlBtns="videoOptions.controlBtns"
            @ended="onSongEnd" />
        </div>
      </div>     
    </div>

    <footer class="bg-primary text-white text-center player-footer" @click="handleFooterClick">
      <div class="container-fluid p-1">
        <div class="btn-container">
            <button type="button" class="btn btn-danger btn-sm btn-spacing" data-action="nextSong">下一首</button>
            <button type="button" class="btn btn-success btn-sm btn-spacing" data-action="pauseVideo">暫停</button>
            <button type="button" class="btn btn-secondary btn-sm btn-spacing" data-action="playVideo">播放</button>
            <button type="button" class="btn btn-warning btn-sm btn-spacing" data-action="toggleFullscreen">全屏</button>
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, nextTick, onUnmounted, watch, provide } from 'vue';
import LongzeVideoPlay from 'longze-vue3-video-player';
import axios from 'axios';
import Footb from './footb.vue';
import { usePlaylistStore } from '../stores/usePlaylistStore';
import { useUserStore } from '@/store/useUserStore';
import { getCookie } from './csrf.js';
import * as youtubePlayer from '@/pupputeerJS/youtube-player.js';
import { useRouter } from 'vue-router';

const publicUrl = import.meta.env.VITE_PUBLIC_URL || '${import.meta.env.VITE_PUBLIC_URL}';
const store = usePlaylistStore();


const videoSource = ref('')
// const isYouTube = ref(true)
const isYouTube = ref(true)
const videoId = ref('aKmGFrBsfiA')
// const videoId = ref('2mCcc7uWaBg')
const currentVideoName = ref('示例視頻')
const origin = ref(window?.location?.origin || '')
let player = null
const isMuted = ref(false)
const nextsongflag = ref(false)
const isFullscreen = ref(false)
const currentSong = ref(null);
provide('currentSong', currentSong);

const userStore = useUserStore();

const showUsername = ref(false);

const router = useRouter();

// 創建一個配置了的 axios 實例
// 動態設置 API base URL
const isOrdersongPath = window.location.pathname.startsWith('/ordersong/');
const axiosInstance = axios.create({
  baseURL: isOrdersongPath ? '/ordersong/api' : '/api',
  timeout: 5000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// 添加全局變量來跟踪外部播放器的狀態
const externalPlayerActive = ref(false);
const songEndHandled = ref(false);

// 修改全局變量，使用普通數組而不是響應式變量
// const externalWindows = ref([]); // 移除這行
let externalWindows = []; // 使用普通數組

const handleVideoSource = async (source) => {
  try {
    // 如果外部播放器已激活，則不再嘗試加載新視頻
    if (externalPlayerActive.value) {
      console.log('外部播放器已激活，不再嘗試加載新視頻');
      return;
    }
    
    // 添加 User-Agent 檢查
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobile = /mobile|android|iphone|ipad|ipod/i.test(userAgent);
    
    if (source.type === 'youtube' || (source.filename && source.filename.includes('youtube.com'))) {
      isYouTube.value = true;
      let id = '';
      
      // 從 URL 中提取 YouTube ID
      const url = source.filename || '';
      const cleanUrl = decodeURIComponent(url)
        .replace('https://127.0.0.1:8000/media/https%3A/', '')
        .replace('@https://', '')
        .replace('https://', '');
      
      const match = cleanUrl.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&?/]+)/);
      id = match ? match[1] : null;

      if (!id) {
        console.error('無法從 URL 提取 YouTube ID:', cleanUrl);
        stateB.value = true;
        return;
      }

      // console.log('提取的 YouTube ID:', id);
      videoId.value = id;
      currentVideoName.value = 'YouTube視頻';
      console.log('正在加載 YouTube 視頻:', id);

      try {
        if (player && typeof player.loadVideoById === 'function') {
          console.log('使用現有播放器加載新視頻');
          
          // 檢查是否為 YouTube 視頻（通過 filename 或 id 格式判斷）
          const isYouTubeVideo = currentSong.value?.filename?.includes('youtube.com') || 
                                 currentSong.value?.filename?.includes('youtu.be') ||
                                 (currentSong.value?.id && currentSong.value.id.length === 11); // YouTube ID 通常是 11 個字符
          
          if (!isYouTubeVideo) {
            // 只有非 YouTube 視頻才嘗試從後端獲取歌曲信息
            try {
              // 先獲取歌曲的完整信息
              const songResponse = await axiosInstance.get(`/songs/${currentSong.value.id}/songchargeA/`);
              const songInfo = songResponse.data;
              
              // 更新當前歌曲信息
              if (currentSong.value) {
                currentSong.value = {
                  ...currentSong.value,
                  start_time: songInfo.start_time,
                  end_time: songInfo.end_time
                };
              }
              
              console.log('視頻信息:', {
                id: id,
                start_time: currentSong.value?.start_time || 0,
                end_time: currentSong.value?.end_time || 0
              });
            } catch (error) {
              // 如果是 404 錯誤，靜默處理（可能是 YouTube 視頻或其他原因）
              if (error.response?.status === 404) {
                console.log('歌曲信息不存在於數據庫（可能是 YouTube 視頻），使用默認值');
              } else {
                console.error('獲取歌曲信息失敗:', error);
              }
            }
          } else {
            console.log('檢測到 YouTube 視頻，跳過後端 API 調用');
          }
          
          // 重置計數器
          if (player.zeroCount) {
            player.zeroCount = 0;
          }
          
          // 加載新視頻（無論是否獲取到歌曲信息）
          player.loadVideoById({
            videoId: id,
            startSeconds: currentSong.value?.start_time || 0
          });
          
          // 確保監控被設置
          setupYouTubeMonitoring();
        } else {
          console.log('播放器未就緒，等待 YouTube API 加載');
          // 如果播放器未就緒，等待 API 加載
          if (!window.YT) {
            const tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            const firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
          }
        }
      } catch (error) {
        console.error('加載 YouTube 視頻時出錯:', error);
      }
    } else {
      isYouTube.value = false;
      // 處理本地視頻
      const baseUrl = 'https://localhost'; // 或者使用您的實際基礎URL
      const newSrc = `${baseUrl}/playlist/${source.filename}`;
      videoOptions.src = newSrc;
      videoSrc.value = newSrc;
      await nextTick();
      setupVideoPlayer(currentSong.value);
    }
  } catch (error) {
    console.error('處理視頻源時出錯:', error);
  }
};

const { playlist, addSong, removeSong } = store;
// const username = ref('');


// const videoSrc = ref('${import.meta.env.VITE_NGINX_URL}/Coastline.mp4'); 
const videoSrc = ref(`https://localhost/Coastline.mp4`);
let newWindow;

const openNewWindow = () => { 
    newWindow = window.open('${import.meta.env.VITE_NGINX_URL}/About.html', 'newWindow', 'width=800,height=600'); 
    newWindow.onload = () => { 
        setTimeout(() => {
            newWindow.postMessage({ videoSrc: videoSrc.value }, '*'); 
        }, 1000); // 延遲1秒發送消息
    }; 
    // console.log(newWindow.value);
    if (newWindow) {
          newWindow.postMessage('requestFullscreen', '*');
      };
};

const sendMessageToNewWindow = (message) => {
  if (newWindow) {
      newWindow.postMessage(message, '*');
  }
};

const onSongEndOrNext = (nextSong) => {
  if (nextSong) {
      // const newSrc = "${import.meta.env.VITE_NGINX_URL}/" + nextSong.filename;
      const newSrc = `${baseUrlA}/playlist/${nextSong.filename}`;  // 修改這裡
      videoSrc.value = newSrc;
      console.log('Sending new videoSrc:', videoSrc.value);
      sendMessageToNewWindow({ videoSrc: newSrc });
  } else {
      console.log('nextSong.no');
  }
};

// const baseUrl = 'https://localhost'移至前端
// const newSrc = `${baseUrlA}/playlist/${nextSong.filename}`;
//       videoOptions.src = newSrc;
//       videoSrc.value = newSrc;
//       isYouTube.value = false;
//       console.log('實際視頻URL:', newSrc);


const baseUrlA = window.location.protocol + '//' + window.location.host;
// const baseUrlA = 'https://localhost';
const videoPlayer = ref(null);
const videoOptions = reactive({
  // src: '${import.meta.env.VITE_NGINX_URL}/Coastline.mp4',
  src: `${baseUrlA}/playlist/Coastline.mp4`,
  type: 'video/mp4',
  width: "480px" ,
  height: "240" , 
  autoPlay: true, //自动播放
  control: true, //是否显示控制
  controlBtns: ['play', 'pause', 'volume', 'fullscreen', 'audioTrack']
})

// videoOptions.src = `${baseUrlA}/playlist/Coastline.mp4`;


const onFileChange = (event) => {
  const file = event.target.files[0];
  if (file) {
    videoOptions.src = URL.createObjectURL(file);
  }
};


const playVideo = () => {
  if (isYouTube.value) {
    const iframe = document.getElementById('youtube-player')
    if (iframe) {
      iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
    }
  } else {
    videoPlayer.value.play()
  }
};

const pauseVideo = () => {
  if (isYouTube.value) {
    const iframe = document.getElementById('youtube-player')
    if (iframe) {
      iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
    }
  } else {
    videoPlayer.value.pause()
  }
};

const adjustVolume = (event) => {
const videoElement = videoPlayer.value.$el.querySelector('video');
videoElement.volume = event.target.value;
};

const toggleFullscreen = () => {
  if(isYouTube.value){
    try {
      const iframe = document.querySelector('#youtube-player');
      if (!isFullscreen.value) {
        player.playVideo()
        setTimeout(() => {
          const requestFullScreen = iframe.requestFullscreen || 
                                  iframe.mozRequestFullScreen || 
                                  iframe.webkitRequestFullscreen || 
                                  iframe.msRequestFullscreen
          if (requestFullScreen) {
            requestFullScreen.call(iframe)
            isFullscreen.value = true
            // showNotification('進入全屏')
          }
        }, 100)
      } else {
        const exitFullscreen = document.exitFullscreen ||
                             document.mozCancelFullScreen ||
                             document.webkitExitFullscreen ||
                             document.msExitFullscreen
        if (exitFullscreen) {
          exitFullscreen.call(document)
          isFullscreen.value = false
          // showNotification('退出全屏')
        }
      }
    } catch (error) {
      console.error('全屏切換失敗:', error)
      // showNotification('全屏切換失敗');
    }
  
  
  } else{
  sendMessageToNewWindow('toggleFullscreen')
    const videoElement = videoPlayer.value.$el.querySelector('video')
  if (videoElement.requestFullscreen) {
    videoElement.requestFullscreen();
  } else if (videoElement.webkitRequestFullscreen) {
    videoElement.webkitRequestFullscreen();
  } else if (videoElement.mozRequestFullScreen) {
    videoElement.mozRequestFullScreen()
  } else if (videoElement.msRequestFullscreen) {
    videoElement.msRequestFullscreen()
  }
}
}


const toggleAudioTrack = () => {
sendMessageToNewWindow('toggleAudioTrack');
const videoElement = videoPlayer.value.$el.querySelector('video');
const tracks = videoElement.audioTracks;
console.log(tracks); // 檢查 tracks 的結構
if (tracks && tracks.length > 0) {
  for (let i = 0; i < tracks.length; i++) {
    tracks[i].enabled = !tracks[i].enabled;
  }
}
// 暫停並重新播放視頻以確保同步
const currentTime = videoElement.currentTime;
videoElement.pause();
videoElement.currentTime = currentTime;
videoElement.play();
};

const nextSong = async () => {
  try {
    console.log('nextSong event received');
    nextsongflag.value = true;

    // 關閉所有可能打開的外部窗口
    closeAllExternalWindows();
    
    // 重置外部播放器標記
    externalPlayerActive.value = false;
    songEndHandled.value = false;
    
    // 處理歌曲結束
    await handleSongEnd();
  } catch (error) {
    console.error('處理 nextSong 事件時出錯:', error);
  }
};

const toggleMute = () => {
  if (isYouTube.value) {
    const iframe = document.getElementById('youtube-player')
    if (iframe) {
      if (isMuted.value) {
        iframe.contentWindow.postMessage('{"event":"command","func":"unMute","args":""}', '*')
      } else {
        iframe.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*')
      }
      isMuted.value = !isMuted.value
    }
  } else {
    const videoElement = videoPlayer.value.$el.querySelector('video')
    videoElement.muted = !videoElement.muted
  }
};

const replaySong = () => {
  if (isYouTube.value) {
    const iframe = document.getElementById('youtube-player')
    if (iframe) {
      iframe.contentWindow.postMessage('{"event":"command","func":"seekTo","args":[0]}', '*')
      iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
    }
  } else {
    const videoElement = videoPlayer.value.$el.querySelector('video')
    videoElement.currentTime = 0
    videoElement.play()
  }
};

//  const customerId = 'your-customer-id';
//  const songId = 'your-song-id';
 const customerId = 1;
 const songId = 201;
 const balancePoints = ref(100);
 const songchargea = ref(1);
 const stateA = ref(true);
 const stateB = ref(false);
 const playCount = ref(0); // 添加播放计数器


const fetchBalancePoints = async () => {
  try {
    const customId = userStore.user?.customer_id;
    if (!customId) {
      console.error('未找到用户customer_id');
      return;
    }
    
    console.log('获取用户余额，customId:', customId);
    const response = await axiosInstance.get(`/customer/${customId}/balancepoints/`);
    
    console.log('余额响应:', response.data);
    if (response.data && response.data.balancepoints !== undefined) {
      balancePoints.value = response.data.balancepoints;
      console.log('当前余额:', balancePoints.value);
    }
  } catch (error) {
    console.error('获取余额失败:', error);
  }
};

const fetchSongCharge = async (songId) => {
  try {
    console.log(`Fetching song charge for song ID: ${songId}`);
    
    // 檢查是否為 YouTube 視頻 ID（通常是 11 個字符）
    // 或者檢查當前歌曲的 filename 是否包含 youtube.com
    const isYouTubeVideo = (songId && songId.length === 11) || 
                           (currentSong.value?.filename && 
                            (currentSong.value.filename.includes('youtube.com') || 
                             currentSong.value.filename.includes('youtu.be')));
    
    if (isYouTubeVideo) {
      console.log('檢測到 YouTube 視頻，跳過收費查詢，使用默認值');
      songchargea.value = 1;  // YouTube 視頻使用默認收費
      return 1;
    }
    
    // 使用 axiosInstance 確保路徑一致性
    const response = await axiosInstance.get(`/songs/${songId}/songchargeA/`);
    
    console.log('Song charge response:', response.data);
    if (response.data && response.data.songChargeA !== undefined) {
      songchargea.value = response.data.songChargeA;
      console.log('songchargea.value:', songchargea.value);
      return response.data.songChargeA;
    } else {
      console.log('使用默認歌曲收費');
      songchargea.value = 1;  // 使用默認值
      return 1;
    }
  } catch (error) {
    // 如果是 404 錯誤（可能是 YouTube 視頻），靜默處理
    if (error.response?.status === 404) {
      console.log('歌曲信息不存在於數據庫（可能是 YouTube 視頻），使用默認收費');
    } else {
      console.error('Error fetching song charge:', error);
    }
    console.log('使用默認歌曲收費');
    songchargea.value = 1;  // 發生錯誤時使用默認值
    return 1;
  }
};

  const firstSongStateA = computed(() => {
    return store.playlist.length > 0 ? store.playlist[0].stateA : null;
  });

  const firstSongStateB = computed(() => {
    return store.playlist.length > 0 ? store.playlist[0].stateB : null;
  });

// 播放狀態管理
const playState = reactive({
  isPlaying: false,
  isProcessingEnd: false,
  currentTime: 0,
  totalDuration: 0,
  remainingTime: 0
});

// 清理計時器
const clearTimers = () => {
  if (player && player.endTimeCheckInterval) {
    clearInterval(player.endTimeCheckInterval);
    player.endTimeCheckInterval = null;
  }
  if (window.localVideoInterval) {
    clearInterval(window.localVideoInterval);
    window.localVideoInterval = null;
  }
};

// 統一的播放狀態更新
const updatePlayState = (currentTime, totalDuration) => {
  playState.currentTime = currentTime;
  playState.totalDuration = totalDuration;
  
  if (currentSong.value && currentSong.value.end_time > 0) {
    playState.remainingTime = currentSong.value.end_time - currentTime;
  } else {
    playState.remainingTime = totalDuration - currentTime;
  }
};

// 檢查是否需要切換到下一首
const checkSongEnd = () => {
  if (playState.isProcessingEnd) return;
  
  const { currentTime, totalDuration, remainingTime } = playState;
  
  if (!currentSong.value || currentSong.value.end_time === 0) {
    if (totalDuration - currentTime <= 1) {
      handleSongEnd();
    }
  } else if (currentTime >= currentSong.value.end_time) {
    handleSongEnd();
  }
};

// 統一的歌曲結束處理
const handleSongEnd = async () => {
  try {
    // 如果已經在處理歌曲結束，則直接返回
    if (playState.isProcessingEnd) {
      console.log('已經在處理歌曲結束，忽略重複調用');
      return;
    }
    
    // 設置處理標記
    playState.isProcessingEnd = true;
    
    console.log('處理歌曲結束');
    
    // 關閉所有可能打開的外部窗口
    closeAllExternalWindows();
    
    // 清理計時器
    clearTimers();
    
    // 暫停當前播放
    if (isYouTube.value && player) {
      player.pauseVideo();
    } else if (videoPlayer.value) {
      videoPlayer.value.pause();
    }
    
    // 播放下一首歌曲
    await playNextSong();
    
    // 重置處理標記
    playState.isProcessingEnd = false;
    
    // 重置外部播放器標記
    externalPlayerActive.value = false;
    songEndHandled.value = false;
  } catch (error) {
    console.error('處理歌曲結束時出錯:', error);
    // 重置處理標記
    playState.isProcessingEnd = false;
    externalPlayerActive.value = false;
    songEndHandled.value = false;
  }
};

// 修改 setupYouTubeMonitoring 函數
const setupYouTubeMonitoring = () => {
  // 清除之前的監控
  if (player.endTimeCheckInterval) {
    clearInterval(player.endTimeCheckInterval);
    player.endTimeCheckInterval = null;
  }
  
  // 只有在外部播放器未激活時才設置新的監控
  if (externalPlayerActive.value) {
    console.log('外部播放器已激活，不設置新的監控');
    return;
  }
  
  player.endTimeCheckInterval = setInterval(() => {
    try {
      // 如果外部播放器已經激活，則停止監控
      if (externalPlayerActive.value) {
        console.log('外部播放器已激活，停止監控');
        clearInterval(player.endTimeCheckInterval);
        player.endTimeCheckInterval = null;
        return;
      }
      
      if (!player || typeof player.getCurrentTime !== 'function') {
        console.log('播放器未就緒');
        return;
      }

      const currentTime = player.getCurrentTime() || 0;
      const totalDuration = player.getDuration() || 0;
      
      if (isNaN(currentTime) || isNaN(totalDuration)) {
        console.log('等待視頻加載...');
        return;
      }

      // 計算剩餘時間
      let remainingTime;
      if (currentSong.value && currentSong.value.end_time > 0) {
        remainingTime = currentSong.value.end_time - currentTime;
      } else {
        remainingTime = totalDuration - currentTime;
      }

      // 檢查是否所有值都為0
      const allZero = Math.floor(currentTime) === 0 && 
                     Math.floor(totalDuration) === 0 && 
                     Math.floor(remainingTime) === 0;
                     
      // 如果全為0則計數加1,否則重置計數
      if (allZero) {
        player.zeroCount = (player.zeroCount || 0) + 1;
      } else {
        player.zeroCount = 0;
      }
      
      // console.log('播放進度 - 當前:', Math.floor(currentTime), '秒',
      //            '總時長:', Math.floor(totalDuration), '秒',
      //            '剩餘:', Math.floor(remainingTime), '秒',
      //            '零值計數:', player.zeroCount || 0,
      //            '外部播放器激活:', externalPlayerActive.value);
      
      // 如果連續3次全為0,則切換到原生播放
      if (player.zeroCount >= 10 && !externalPlayerActive.value) {
        console.log('YouTube嵌入式播放器無法播放,切換到原生播放');
        // 立即設置外部播放器標記，防止重複觸發
        externalPlayerActive.value = true;
        
        // 重置處理標記
        songEndHandled.value = false;
        
        // 重置計數並暫停播放器
        player.zeroCount = 0;
        player.pauseVideo();
        
        // 清除監控計時器
        clearInterval(player.endTimeCheckInterval);
        player.endTimeCheckInterval = null;
        
        try {
          console.log('嘗試使用 youtube-player.js 進行播放');
          
          // 檢查 play 方法是否返回 Promise
          const playPromise = youtubePlayer.play(videoId.value, {
            startTime: currentSong.value?.start_time || 0,
            endTime: currentSong.value?.end_time || 0,
            onQKeyPress: () => {
              // 當用戶按下 Q 鍵時的回調
              console.log('用戶按下 Q 鍵結束播放');
              if (!songEndHandled.value) {
                songEndHandled.value = true;
                console.log('外部播放器被用戶手動結束，準備切換到下一首');
                // 使用 setTimeout 確保在 UI 更新後執行
                setTimeout(() => {
                  // 重置外部播放器標記，允許下一首歌曲使用嵌入式播放器
                  externalPlayerActive.value = false;
                  handleSongEnd();
                }, 500);
              }
              return true; // 返回 true 表示已處理
            },
            onWindowOpen: (window) => {
              // 記錄打開的窗口
              if (window) {
                console.log('記錄新打開的外部窗口');
                externalWindows.push(window);
              }
            }
          });
          
          // 檢查返回值是否為 Promise
          if (playPromise && typeof playPromise.then === 'function') {
            playPromise.then(result => {
              console.log('youtube-player.js 播放結果:', result);
              
              // 如果結果為 true 但沒有實際播放完成，不要立即切換
              // 而是等待用戶手動切換或設置一個較長的超時
              if (result === true) {
                console.log('外部播放器已啟動，等待播放完成或用戶手動切換');
                
                // 設置一個較長的超時，例如歌曲的預計長度或默認 5 分鐘
                const timeout = (currentSong.value?.end_time && currentSong.value?.start_time && currentSong.value.end_time > currentSong.value.start_time) 
                  ? (currentSong.value.end_time - currentSong.value.start_time) * 1000 
                  : 5 * 60 * 1000;
                
                console.log(`設置超時: ${timeout/1000} 秒後將自動切換下一首`);
                
                // 只有在超時後才自動切換
                setTimeout(() => {
                  if (!songEndHandled.value) {
                    songEndHandled.value = true;
                    console.log('外部播放器超時，準備切換到下一首');
                    // 重置外部播放器標記，允許下一首歌曲使用嵌入式播放器
                    externalPlayerActive.value = false;
                    handleSongEnd();
                  }
                }, timeout);
              } else {
                // 如果結果不是 true，可能表示播放失敗或已完成
                if (!songEndHandled.value) {
                  songEndHandled.value = true;
                  console.log('外部播放器播放完成或失敗，準備切換到下一首');
                  // 使用 setTimeout 確保在 UI 更新後執行
                  setTimeout(() => {
                    // 重置外部播放器標記，允許下一首歌曲使用嵌入式播放器
                    externalPlayerActive.value = false;
                    handleSongEnd();
                  }, 500);
                }
              }
            }).catch(error => {
              console.error('youtube-player.js 播放失敗:', error);
              // 如果播放失敗，跳到下一首，但只在尚未處理時執行
              if (!songEndHandled.value) {
                songEndHandled.value = true;
                console.log('外部播放器播放失敗，準備切換到下一首');
                // 使用 setTimeout 確保在 UI 更新後執行
                setTimeout(() => {
                  // 重置外部播放器標記，允許下一首歌曲使用嵌入式播放器
                  externalPlayerActive.value = false;
                  handleSongEnd();
                }, 500);
              }
            });
          } else {
            console.error('youtube-player.js 的 play 方法沒有返回 Promise');
            // 如果 play 方法沒有返回 Promise，設置一個默認的超時
            setTimeout(() => {
              if (!songEndHandled.value) {
                songEndHandled.value = true;
                console.log('外部播放器可能已啟動，但無法確認狀態，設置默認超時');
                // 重置外部播放器標記，允許下一首歌曲使用嵌入式播放器
                externalPlayerActive.value = false;
                handleSongEnd();
              }
            }, 5 * 60 * 1000); // 5分鐘
          }
        } catch (error) {
          console.error('切換到備用播放方式失敗:', error);
          console.log('備用播放方式失敗，準備切換到下一首');
          // 使用 setTimeout 確保在 UI 更新後執行
          setTimeout(() => {
            // 重置外部播放器標記，允許下一首歌曲使用嵌入式播放器
            externalPlayerActive.value = false;
            handleSongEnd();
          }, 500);
        }
        
        // 避免繼續執行後續代碼
        return;
      }

      // 檢查是否需要結束播放
      if (currentSong.value && currentSong.value.end_time > 0) {
        // 有設定結束時間的情況
        if (currentTime >= currentSong.value.end_time) {
          // console.log('達到指定結束時間，切換下一首');
          clearInterval(player.endTimeCheckInterval);
          player.pauseVideo();
          handleSongEnd();
        }
      } else if (totalDuration > 0) {
        // 沒有設定結束時間或結束時間為0的情況
        // 當剩餘時間小於等於1秒或當前時間已達到總時長時切換
        if (remainingTime <= 1 || currentTime >= totalDuration - 1) {
          // console.log('視頻即將結束，準備切換下一首');
          clearInterval(player.endTimeCheckInterval);
          player.pauseVideo();
          handleSongEnd();
        }
      }

      updatePlayState(currentTime, totalDuration);
    } catch (error) {
      console.error('時間監控出錯:', error);
      if (player.endTimeCheckInterval) {
        clearInterval(player.endTimeCheckInterval);
      }
    }
  }, 1200);
};

const onSongEnd = () => {
  console.log('歌曲播放结束事件触发');
  if (!isYouTube.value && videoPlayer.value) {
    const videoElement = videoPlayer.value.$el.querySelector('video');
    if (videoElement) {
      videoElement.pause();
    }
  }
  handleSongEnd();
};

// const baseUrlA = window.location.protocol + '//' + window.location.host + '/playlist';
const initializeVideo = async () => {
  // 暫時屏蔽本地視頻播放功能
  console.log('本地視頻播放功能已屏蔽');
  return;
  
  // 原始代碼（已屏蔽）
  /*
  try {
    console.log('開始初始化視頻...');
    const filename = 'Coastline.mp4';
    const fullPath = `${baseUrlA}/playlist/${filename}`;
    console.log('完整文件路徑:', fullPath);
    
    // 檢查文件是否存在
    try {
      const response = await fetch(fullPath, { 
        method: 'HEAD',
        headers: {
          'Cache-Control': 'no-cache'
        }
      });
      
      if (!response.ok) {
        throw new Error(`文件不存在 (狀態碼: ${response.status})`);
      }
      
      console.log('文件存在，可以播放');
      videoOptions.src = fullPath;
      videoSrc.value = fullPath;
      
      await nextTick();
      
      if (!videoPlayer.value) {
        throw new Error('未找到視頻播放器引用');
      }

      const videoElement = videoPlayer.value.$el.querySelector('video');
      if (!videoElement) {
        throw new Error('未找到視頻元素');
      }

      console.log('找到視頻元素，開始設置播放器...');
      videoElement.load();
      
      try {
        await videoElement.play();
        console.log('視頻開始播放');
      } catch (err) {
        console.error('播放失敗:', err.message);
        throw err;
      }

    } catch (error) {
      console.error('視頻初始化失敗:', error.message);
      throw error;
    }
  } catch (error) {
    console.error('整體初始化失敗:', error.message);
  }
  */
};


onMounted(async () => {

  console.log('組件掛載開始...');
  
  // 等待 DOM 完全加載
  await nextTick();
  await new Promise(resolve => setTimeout(resolve, 100));
  
  try {
    console.log('準備初始化視頻...');
    await initializeVideo();
    console.log('視頻初始化流程完成');
  } catch (error) {
    console.error('視頻初始化失敗:', error);
  }

  // 重置播放次數
  playCount.value = 0;
  
  // 移除直接调用 fetchBalancePoints
  fetchSongCharge(songId);
  origin.value = window.location.origin;
  showUsername.value = userStore.isLoggedIn && userStore.user;

  // 如果用户已登录，则获取余额
  if (userStore.isLoggedIn && userStore.user?.customer_id) {
    await fetchBalancePoints();
  }

  // 加載 YouTube IFrame API
  if (!window.YT) {
    const tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  // 定義 YouTube API 就緒時的回調函數
  window.onYouTubeIframeAPIReady = () => {
    console.log('YouTube IFrame API 已加載');
    const iframe = document.getElementById('youtube-player');
    if (iframe) {
      player = new window.YT.Player('youtube-player', {
        events: {
          'onReady': (event) => {
            console.log('YouTube 播放器已就緒');
            // 重置外部播放器標記
            externalPlayerActive.value = false;
            
            if (currentSong.value && currentSong.value.start_time) {
              event.target.seekTo(currentSong.value.start_time);
            }
            event.target.playVideo();
          },
          'onStateChange': (event) => {
            console.log('播放狀態改變:', event.data);
            if (event.data === window.YT.PlayerState.PLAYING) {
              // 播放開始時重置外部播放器標記
              externalPlayerActive.value = false;
              setupYouTubeMonitoring();
            }
            else if (event.data === window.YT.PlayerState.ENDED) {
              // console.log('YouTube視頻播放結束，準備播放下一首');
              clearTimers();
              onSongEnd();
            }
          }
        }
      });
    }
  };

  // 檢查用戶是否已登入
  if (!userStore.isLoggedIn) {
    // 從 localStorage 恢復播放次數
    const storedCount = localStorage.getItem('playCount');
    if (storedCount) {
      playCount.value = parseInt(storedCount, 10);
    }
  }

});

  document.addEventListener('fullscreenchange', () => {
    isFullscreen.value = !!document.fullscreenElement
  })
  
  document.addEventListener('webkitfullscreenchange', () => {
    isFullscreen.value = !!document.webkitFullscreenElement
  })
  
  document.addEventListener('msfullscreenchange', () => {
    isFullscreen.value = !!document.msFullscreenElement
  })

onUnmounted(() => {
  clearTimers();
  store.clearCurrentSongId();
})

// 修改 watch 部分，添加获取余额的逻辑
watch([() => userStore.isLoggedIn, () => userStore.user], async ([isLoggedIn, user]) => {
  if (isLoggedIn && user) {
    nextTick(async () => {
      showUsername.value = true;
      await fetchBalancePoints(); // 在用户登录后获取余额
    });
  }
}, { immediate: true, deep: true });

// 修改 videoId 相關的處理
watch(currentSong, (newSong) => {
  if (newSong) {
    store.setCurrentPlayingSong({
      id: newSong.id,
      songname: newSong.songname,
      filename: newSong.filename
    });
  }
}, { immediate: true, deep: true });

// 添加登錄狀態監聽
watch(() => userStore.isLoggedIn, (newLoginState) => {
  if (newLoginState) {
    // 用戶登錄時重置播放次數
    playCount.value = 0;
    console.log('用戶已登錄，重置播放次數');
  }
});

const baseUrl = 'https://localhost'; // 因為您使用的是 HTTPS
// 修改 playNextSong 函數
const playNextSong = async () => {
  try {
    console.log('開始播放下一首歌曲');
    
    // 重置外部播放器標記，允許新歌曲使用嵌入式播放器
    externalPlayerActive.value = false;
    songEndHandled.value = false;
    
    // 檢查播放列表是否存在
    const currentPlaylist = store.getPlaylist;
    if ((!currentPlaylist || currentPlaylist.length === 0) && nextsongflag.value === true) {
      console.log('播放列表為空或未初始化');
      nextsongflag.value = false;
      try {
        const response = await axiosInstance.get('/featured_songs/', {
          params: {
            featured_type: 'CA',
            page_size: 100,
            page: Math.floor(Math.random() * 3) + 1   
          }
        });

        if (response.data.results && response.data.results.length > 0) {
          // 隨機選擇一首歌
          const randomIndex = Math.floor(Math.random() * response.data.results.length);
          const randomSong = response.data.results[randomIndex];
          
          // 設置當前歌曲信息
          currentSong.value = {
            id: randomSong.id,
            songname: randomSong.songname,
            filename: randomSong.filename,
            start_time: randomSong.start_time || 0,
            end_time: randomSong.end_time || 0
          };

          console.log('選擇的隨機歌曲:', currentSong.value);

          if (randomSong.filename && randomSong.filename.includes('youtube.com')) {
            await handleVideoSource({
              type: 'youtube',
              filename: randomSong.filename
            });
          } else {
            // const baseUrl = import.meta.env.VITE_NGINX_URL || '';
            // videoOptions.src = "${import.meta.env.VITE_NGINX_URL}/" + randomSong.filename;
            // videoOptions.src = `${baseUrl}/${randomSong.filename}`;
            videoOptions.src = `${baseUrl}/Coastline.mp4`;
            isYouTube.value = false;
            console.log('isYouTube.value = false');
            await nextTick();
            setupVideoPlayer(currentSong.value);
          }
        } else {
          console.log('沒有可用的推薦歌曲');
        }
      } catch (error) {
        console.error('獲取推薦歌曲失敗:', error);
      }
      return;
    }

    // 获取下一首歌曲信息
    const nextSong = currentPlaylist[0];
    if (!nextSong) {
      console.log('沒有下一首歌曲');
      return;
    }

    // 已登录用户进行使用期限检查
    if (userStore.isLoggedIn) {
      const customId = userStore.userId;
      if (!customId) {
        console.log('未找到用户customer_id');
        return;
      }

      try {
        // 获取用户到期日期
        const expiredResponse = await axiosInstance.get(`/customer/${customId}/expireddate/`);
        const expiredDate = new Date(expiredResponse.data.expireddate);
        const currentDate = new Date();

        console.log('使用期限檢查 - 到期日期:', expiredDate, '當前日期:', currentDate);

        // 检查是否已过期
        if (currentDate > expiredDate) {
          alert('您的會員已過期，請充值續期！');
          // 可以在这里添加导航到充值页面的代码
          router.push('/recharge');
          return;
        }

        // 计算剩余天数
        const remainingDays = Math.ceil((expiredDate - currentDate) / (1000 * 60 * 60 * 24));
        
        // 如果剩余天数少于7天，提醒用户
        if (remainingDays <= 7) {
          alert(`您的會員將在 ${remainingDays} 天後到期，請及時續期！`);
        }

        // 记录用户IP (可选) - 前端無法直接獲取真實IP，跳過此功能
        // 注意：IP記錄功能需要在後端實現，前端無法直接獲取用戶真實IP
        console.log('IP記錄功能已跳過（前端無法獲取真實IP）');
      } catch (error) {
        console.error('使用期限檢查失敗:', error);
        // 如果无法检查到期日期，允许播放但记录错误
        console.log('無法檢查會員到期日期，允許播放');
      }
    }

    console.log('准备播放:', nextSong.songname);
    currentSong.value = nextSong;
    store.removeSong(nextSong.id);
    nextsongflag.value = false;
    
    // 处理视频源
    if (nextSong.filename && (nextSong.filename.includes('youtube.com') || nextSong.filename.includes('@youtube.com'))) {
      await handleVideoSource({
        type: 'youtube',
        filename: nextSong.filename
      });
      // console.log('歌曲信息:YTnewSrc', newSrc);
    } else {
      const baseUrl = 'https://localhost';// const baseUrl = 'https://localhost'移至前端
      const newSrc = `${baseUrl}/playlist/${nextSong.filename}`;
      videoOptions.src = newSrc;
      videoSrc.value = newSrc;
      isYouTube.value = false;
      console.log('實際視頻URL:', newSrc);
      await nextTick();
      setupVideoPlayer(nextSong);
    }

  } catch (error) {
    console.error('播放下一首歌曲時出錯:', error);
    // 重置標記
    externalPlayerActive.value = false;
    songEndHandled.value = false;
  }
};

// 修改 closeAllExternalWindows 函數
const closeAllExternalWindows = () => {
  // console.log('嘗試關閉所有外部窗口');
  
  // 關閉記錄的外部窗口
  externalWindows.forEach(window => {
    try {
      if (window && !window.closed) {
        // console.log('關閉外部窗口');
        window.close();
      }
    } catch (error) {
      console.error('關閉外部窗口時出錯:', error);
    }
  });
  
  // 清空窗口列表
  externalWindows = [];
  
  // 嘗試使用 youtubePlayer 模塊的關閉方法（如果存在）
  if (youtubePlayer && typeof youtubePlayer.closeAll === 'function') {
    console.log('調用 youtubePlayer.closeAll()');
    const result = youtubePlayer.closeAll();
    console.log('關閉結果:', result);
  }
};

const getVideoUrl = (filename) => {
  if (!filename) return '';
  return `${publicUrl}/media/${encodeURIComponent(filename)}`;
};

// 添加事件委託處理函數
const handleFooterClick = (event) => {
  const target = event.target.closest('button');
  if (!target) return;
  
  const action = target.dataset.action;
  if (!action) return;
  
  // 根據按鈕的 data-action 屬性調用相應的方法
  switch (action) {
    case 'nextSong':
      nextSong();
      break;
    case 'pauseVideo':
      pauseVideo();
      break;
    case 'playVideo':
      playVideo();
      break;
    case 'toggleFullscreen':
      toggleFullscreen();
      break;
  }
};

// 設置視頻播放器
const setupVideoPlayer = (song) => {
  const videoElement = videoPlayer.value.$el.querySelector('video');
  if (!videoElement) {
    console.log('未找到視頻元素');
    return;
  }

  console.log('設置視頻播放器，歌曲信息:', song);
  
  videoElement.onerror = (e) => {
    console.error('視頻加載錯誤:', e.target.error);
    console.error('錯誤視頻源:', videoElement.src);
    console.error('完整錯誤信息:', e);
  };
  
  // 移除舊的事件監聽器
  videoElement.removeEventListener('ended', onSongEnd);
  videoElement.removeEventListener('timeupdate', onTimeUpdate);
  
  // 添加新的事件監聽器
  videoElement.addEventListener('ended', onSongEnd);
  videoElement.addEventListener('timeupdate', onTimeUpdate);
  
  // 修改這部分，直接在這裡處理視頻加載完成的邏輯
  videoElement.addEventListener('loadeddata', () => {
    console.log('視頻加載完成，準備播放');
    if (song && song.start_time > 0) {
      videoElement.currentTime = song.start_time;
    }
    videoElement.play().catch(err => {
      console.error('播放失敗:', err);
    });
  });

  // 設置視頻源
  sendMessageToNewWindow({ videoSrc: videoOptions.src });
};

// 添加本地视频监控函数
const setupLocalVideoMonitoring = (videoElement) => {
  if (!videoElement) return;

  if (window.localVideoInterval) {
    clearInterval(window.localVideoInterval);
  }

  window.localVideoInterval = setInterval(() => {
    try {
      const currentTime = videoElement.currentTime;
      const totalDuration = videoElement.duration;
      
      if (isNaN(currentTime) || isNaN(totalDuration)) {
        console.log('等待視頻加載...');
        return;
      }

      // 計算剩餘時間
      let remainingTime;
      if (currentSong.value && currentSong.value.end_time > 0) {
        remainingTime = currentSong.value.end_time - currentTime;
      } else {
        remainingTime = totalDuration - currentTime;
      }

      // console.log('本地視頻監控 - 當前時間:', Math.floor(currentTime), '秒',
      //            '總時長:', Math.floor(totalDuration), '秒',
      //            '剩餘:', Math.floor(remainingTime), '秒');

      // 檢查是否需要切換到下一首
      if (currentSong.value && currentSong.value.end_time > 0) {
        if (currentTime >= currentSong.value.end_time) {
          console.log('達到指定結束時間，切換下一首');
          clearInterval(window.localVideoInterval);
          videoElement.pause();
          handleSongEnd();
          return;
        }
      } else if (totalDuration > 0) {
        if (remainingTime <= 1 || currentTime >= totalDuration - 1) {
          console.log('視頻即將結束，準備切換下一首');
          clearInterval(window.localVideoInterval);
          videoElement.pause();
          handleSongEnd();
          return;
        }
      }

      updatePlayState(currentTime, totalDuration);
    } catch (error) {
      console.error('本地視頻監控出錯:', error);
      clearInterval(window.localVideoInterval);
    }
  }, 1000);
};

// 修改 onTimeUpdate 函数
const onTimeUpdate = () => {
  const videoElement = videoPlayer.value.$el.querySelector('video');
  if (!videoElement) return;

  const currentTime = videoElement.currentTime;
  const totalDuration = videoElement.duration;

  console.log('播放進度 - 當前:', Math.floor(currentTime), '秒',
             '總時長:', Math.floor(totalDuration), '秒');

  // 檢查是否需要結束播放
  if (currentSong.value && currentSong.value.end_time > 0) {
    if (currentTime >= currentSong.value.end_time) {
      console.log('達到指定結束時間，切換下一首');
      videoElement.pause();
      handleSongEnd();
      return;
    }
  } else if (totalDuration > 0 && totalDuration - currentTime <= 0.5) {
    console.log('視頻即將自然結束，準備切換下一首');
    videoElement.pause();
    handleSongEnd();
    return;
  }

  updatePlayState(currentTime, totalDuration);
};



</script>

<style scoped>
/* #player-container {
  position: relative;
  width: 100%;
  height: 100vh;
} */

.player-root {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}

.video-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.youtube-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
 }

.youtube-container #youtube-player {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/* .username-display {
  position: fixed !important;
  top: 10px !important;
  right: 10px !important;
  z-index: 99999999 !important;
  background-color: rgba(0, 123, 255, 0.9) !important;
  color: white !important;
  padding: 8px 15px !important;
  border-radius: 4px !important;
  font-weight: bold !important;
  font-size: 14px !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2) !important;
} */

.player-footer {
  position: fixed !important;
  bottom: 1px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  width: calc(100% - 60px) !important;
  max-width: 600px !important;
  z-index: 2000 !important; /* 適中的 z-index，避免覆蓋 modal */
  background-color: var(--bs-primary) !important;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.5) !important;
  padding: 0 !important;
  border-radius: 8px !important;
  height: auto !important;
  pointer-events: auto !important; /* 確保可以接收點擊事件 */
}

.btn-container {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  flex-wrap: nowrap !important;
  z-index: 2001 !important; /* 按鈕的 z-index 比 footer 更高 */
  padding: 4px 0 !important;
  width: 100% !important; /* 確保容器佔滿整個寬度 */
}

.btn-spacing {
  margin: 0 5px !important;
  padding: 4px 8px !important;
  font-size: 0.85rem !important;
  z-index: 2002 !important; /* 按鈕的 z-index 比 footer 更高 */
  position: relative !important;
  pointer-events: auto !important; /* 確保按鈕可以接收點擊事件 */
}

/* 針對中等屏幕的特殊處理 */
@media (min-width: 768px) and (max-width: 1199px) {
  .player-footer {
    width: calc(100% - 80px) !important;
    max-width: 500px !important;
    bottom: 5px !important; /* 稍微提高位置 */
  }
  
  .btn-container {
    padding: 3px 0 !important;
  }
  
  .btn-spacing {
    margin: 0 4px !important;
    padding: 3px 6px !important;
    font-size: 0.8rem !important;
  }
}

/* 針對小屏幕的處理 */
@media (max-width: 767px) {
  .player-footer {
    width: calc(100% - 40px) !important;
    max-width: none !important;
    bottom: 8px !important; /* 在手機上進一步提高位置 */
  }
  
  .btn-container {
    padding: 2px 0 !important;
  }
  
  .btn-spacing {
    margin: 0 3px !important;
    padding: 2px 5px !important;
    font-size: 0.75rem !important;
  }
}

/* 全屏模式樣式 */
:fullscreen .player-root,
:-webkit-full-screen .player-root,
:-moz-full-screen .player-root,
:-ms-fullscreen .player-root {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: #000;
}

:fullscreen .youtube-container,
:-webkit-full-screen .youtube-container,
:-moz-full-screen .youtube-container,
:-ms-fullscreen .youtube-container {
  width: 100%;
  height: 100%;
}

:fullscreen .youtube-container iframe,
:-webkit-full-screen .youtube-container iframe,
:-moz-full-screen .youtube-container iframe,
:-ms-fullscreen .youtube-container iframe {
  width: 100%;
  height: 100%;
}

.btn-spacing {
  margin-right: 10px;
}


</style>
